module.exports = __webpack_public_path__ + "img/47exp.771f0e2c.jpg";